export const contactMethodOptions = [
  { label: 'Zoom', value: 'zoom' },
  { label: 'WhatsApp', value: 'whatsapp' },
  { label: 'Google Meet', value: 'google_meet' },
  { label: 'Skype', value: 'skype' }
];

export const sessionModeOptions = [
  { label: 'Presencial', value: 'presencial' },
  { label: 'Virtual Sincrónico', value: 'virtual_sincronico' },
  { label: 'Virtual Asincrónico', value: 'virtual_asincronico' },
  { label: 'Híbrido', value: 'hibrido' }
];
